function unlockProgramField() {
  const FIELDS = document.querySelectorAll('select[name="Program"]');

  if (FIELDS.length > 0) {
    FIELDS.forEach((field) => {
      field.disabled = false;
      field.parentElement.classList.remove("spinner");
    });
  }
}

export default unlockProgramField;
